import React from "react";
import { IoMdClose } from "react-icons/io";
import styled from "styled-components";

import { colors } from "../constants/theme";
import { Row, Col } from "./LayoutBlocks";
import Modal from "./Modal";

const ContentContainer = styled.div`
  max-width: 400px;
  font-family: sans-serif;
  p {
    line-height: 1.5em;
  }
`;

const CloseButton = styled.button`
  outline: none;
  background: transparent;
  border: none !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  margin-top: -15px;
  margin-right: -15px;
  &:hover {
    background-color: ${colors.greys[100]};
  }
  span {
    visibility: hidden;
    width: 0;
  }
`;

const CourseModal = ({ closeCourse, fag, ...props }) => {
  const { post_content, post_title } = fag || {};
  return (
    <Modal isOpen onRequestClose={closeCourse} contentLabel="Example Modal">
      <ContentContainer className="studySelector_modal-content">
        <Col>
          <Row between>
            <h2>{post_title}</h2>
            <CloseButton onClick={closeCourse}>
              <IoMdClose color="#ababab" size={26} />
              <span>Close</span>
            </CloseButton>
          </Row>
          <Row>
            <p>{post_content}</p>
          </Row>
          {/* <Row>
            <a href={guid} target="_blank" rel="noopener noreferrer">
              Læs mere
            </a>
          </Row> */}
        </Col>
      </ContentContainer>
    </Modal>
  );
};

export default CourseModal;
